export default __webpack_public_path__ + "static/media/blackboard.5de68096.png";